
import React, { useEffect, useState } from 'react';
import Header from '../Header/Header';
import { FaUser, FaQuestionCircle, FaClipboardList, FaArrowRight, FaCalendarCheck, FaChartLine } from 'react-icons/fa';
import Footer from '../Footer/Footer';
import '../../App.css';
import A2 from '../Images/E2.png';
import l1 from '../Images/Chatbot.jpeg';

const Education = () => {

    const [hovered, setHovered] = useState(null);

    const [animateText, setAnimateText] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setAnimateText(true);
        }, 500);
    }, []);


    const featureBoxStyle = (isHovered) => ({
        backgroundColor: '#ffffff',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        border: isHovered ? '2px solid #003142' : '2px solid transparent',
        transition: 'transform 0.3s ease, border-color 0.3s ease',
        transform: isHovered ? 'scale(1.05)' : 'scale(1)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        height: 'auto',
    });


    const iconStyle = (isHovered) => ({
        color: isHovered ? '#6c8c91' : '#15325b',
        transition: 'color 0.3s ease',
    });



    const [demoFlows, setDemoFlows] = useState([]);
    const [showFlows, setShowFlows] = useState(false);

    const fetchflowconfig = () => {
        fetch('https://rvapi.emedha.in/pages/api/api/eflowconfig')
            .then((response) => response.json())
            .then((data) => {
                setDemoFlows(data);
            })
            .catch((error) => {
                console.error('Error fetching demo flows:', error);
            });
    };

    const handleImageClick = () => {
        if (!showFlows) {
            fetchflowconfig();
        }
        setShowFlows(!showFlows);
    };

    useEffect(() => {
        setTimeout(() => {
            setAnimateText(true);
        }, 500);
    }, []);

    useEffect(() => {
        fetchflowconfig();
    }, []);


    const [selectedFlow, setSelectedFlow] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mobileNumber, setMobileNumber] = useState('');

    const handleSubmit = () => {
        if (selectedFlow) {
            const url = `https://emedha.com/echatbot/send_flow.php?id=${selectedFlow.id}&mobile=${mobileNumber}`;
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    alert('Check your WhatsApp for further instructions.');
                    setIsModalOpen(false);
                })
                .catch(error => {
                    console.error('Error sending flow:', error);
                    alert('There was an error processing your request.');
                });
        }
    };

    const handleFlowClick = (flow) => {
        setSelectedFlow(flow);
        setIsModalOpen(true);
    };


    return (
        <>
            <Header />
            <div className='container rounded'>
                <div className={`home-container ${animateText ? 'animate' : ''}`} >
                    <div className="text-container text-center" >
                        <h1 style={{ fontSize: '46px', marginBottom: '10px', color: '#29308a' }}><strong>Engage and grow<br />student sign ups on</strong></h1>
                        <h2 style={{ fontSize: '44px', color: '#003142', marginBottom: '15px' }}><strong>WhatsApp</strong></h2>
                        <p className='text-black'>
                            Market classes, manage admission, onboard students<br />
                            and keep up to date.
                        </p>
                    </div>
                    <img src={A2} alt="WhatsApp Business" className="logo-img1" />
                </div>

                <div className="container py-5">
                    <div className="p-5 rounded shadow mb-5" style={{ backgroundColor: '#b4b3d3' }}>
                        <h1 className="text-center mb-4">Broadcast Communication for Education</h1>

                        <div className="row row-cols-1 row-cols-md-3 row-cols-lg-2 g-5">
                            <div className="col">
                                <div
                                    style={featureBoxStyle(hovered === 'lead')}
                                    onMouseEnter={() => setHovered('lead')}
                                    onMouseLeave={() => setHovered(null)}
                                    className="d-flex flex-column align-items-start p-3"
                                >
                                    <h2 className="h5 text-primary d-flex align-items-center mb-3">
                                        <FaUser style={{ marginRight: '10px', ...iconStyle(hovered === 'lead') }} />
                                        Lead Management
                                    </h2>
                                    <p style={{ fontSize: '16px', color: '#333' }}>
                                        Engage and attract new students, and integrate with your CRM to broadcast marketing messages on WhatsApp.
                                    </p>
                                </div>
                            </div>

                            <div className="col">
                                <div
                                    style={featureBoxStyle(hovered === 'problem')}
                                    onMouseEnter={() => setHovered('problem')}
                                    onMouseLeave={() => setHovered(null)}
                                    className="d-flex flex-column align-items-start p-3"
                                >
                                    <h2 className="h5 text-primary d-flex align-items-center mb-3">
                                        <FaQuestionCircle style={{ marginRight: '10px', ...iconStyle(hovered === 'problem') }} />
                                        Instant Problem Resolution
                                    </h2>
                                    <p style={{ fontSize: '16px', color: '#333' }}>
                                        Provide quick answers with automated chatbot flows and escalate to support teams when human action is needed.
                                    </p>
                                </div>
                            </div>

                            <div className="col">
                                <div
                                    style={featureBoxStyle(hovered === 'admissions')}
                                    onMouseEnter={() => setHovered('admissions')}
                                    onMouseLeave={() => setHovered(null)}
                                    className="d-flex flex-column align-items-start p-3"
                                >
                                    <h2 className="h5 text-primary d-flex align-items-center mb-3">
                                        <FaClipboardList style={{ marginRight: '10px', ...iconStyle(hovered === 'admissions') }} />
                                        Support For Admissions
                                    </h2>
                                    <p style={{ fontSize: '16px', color: '#333' }}>
                                        Guide parents through your admissions process with chatbots that ensure students sign up correctly.
                                    </p>
                                </div>
                            </div>

                            <div className="col">
                                <div
                                    style={featureBoxStyle(hovered === 'onboarding')}
                                    onMouseEnter={() => setHovered('onboarding')}
                                    onMouseLeave={() => setHovered(null)}
                                    className="d-flex flex-column align-items-start p-3"
                                >
                                    <h2 className="h5 text-primary d-flex align-items-center mb-3">
                                        <FaArrowRight style={{ marginRight: '10px', ...iconStyle(hovered === 'onboarding') }} />
                                        Onboarding Support
                                    </h2>
                                    <p style={{ fontSize: '16px', color: '#333' }}>
                                        Provide instant information to assist students in completing your onboarding process easily.
                                    </p>
                                </div>
                            </div>

                            <div className="col">
                                <div
                                    style={featureBoxStyle(hovered === 'reminders')}
                                    onMouseEnter={() => setHovered('reminders')}
                                    onMouseLeave={() => setHovered(null)}
                                    className="d-flex flex-column align-items-start p-3"
                                >
                                    <h2 className="h5 text-primary d-flex align-items-center mb-3">
                                        <FaCalendarCheck style={{ marginRight: '10px', ...iconStyle(hovered === 'reminders') }} />
                                        Timely Class Reminders
                                    </h2>
                                    <p style={{ fontSize: '16px', color: '#333' }}>
                                        Message students directly on WhatsApp with automated reminders of timetables and classes.
                                    </p>
                                </div>
                            </div>

                            <div className="col">
                                <div
                                    style={featureBoxStyle(hovered === 'reports')}
                                    onMouseEnter={() => setHovered('reports')}
                                    onMouseLeave={() => setHovered(null)}
                                    className="d-flex flex-column align-items-start p-3"
                                >
                                    <h2 className="h5 text-primary d-flex align-items-center mb-3">
                                        <FaChartLine style={{ marginRight: '10px', ...iconStyle(hovered === 'reports') }} />
                                        Student Reports
                                    </h2>
                                    <p style={{ fontSize: '16px', color: '#333' }}>
                                        Instantly deliver reports and exam results to students and parents with automated WhatsApp messages.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div style={{ position: 'relative' }}>
                <img src={l1} alt="Logo" className="logo-img" style={{ width: '80px', position: 'fixed', bottom: '30px', right: '30px', zIndex: '10', borderRadius: '50%', cursor: 'pointer', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', transition: 'transform 0.3s ease-in-out', }} onClick={handleImageClick} onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'} onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'} />
                {showFlows && (
                    <div style={{ position: 'fixed', bottom: '120px', right: '30px', zIndex: '10' }}>
                        {demoFlows.map((flow) => (
                            <div key={flow.id} style={{ marginBottom: '10px' }}>
                                <button
                                    onClick={() => handleFlowClick(flow)}
                                    style={{ width: '220px', padding: '10px', fontSize: '14px', backgroundColor: '#003142', color: 'white', border: 'none', borderRadius: '25px', cursor: 'pointer', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', transition: 'background-color 0.3s, transform 0.2s', }}
                                    onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#45a049'; e.currentTarget.style.transform = 'scale(1.05)'; }}
                                    onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#4CAF50'; e.currentTarget.style.transform = 'scale(1)'; }}
                                >
                                    {flow.display_name}
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {isModalOpen && (
                <div className="modal" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                    <div className="modal-content" style={{ backgroundColor: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', width: '90%', maxWidth: '400px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
                        <span className="close" onClick={() => setIsModalOpen(false)} style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '24px', cursor: 'pointer', color: '#333' }}>&times;</span>
                        <h2>Enter Your Mobile Number</h2>
                        <input type="text" placeholder="Enter mobile number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} style={{ padding: '12px 20px', fontSize: '16px', width: '100%', maxWidth: '300px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: '5px', outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.3s ease' }} />
                        <button onClick={handleSubmit} style={{ padding: '12px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px', width: '100%', maxWidth: '300px', transition: 'background-color 0.3s ease' }}>Submit</button>
                    </div>
                </div>
            )}
            <Footer />
        </>
    );
};

export default Education;
